import type { MailboxInfo } from 'owa-client-types';
import { getStoredMailboxJunkEmailConfiguration } from '../utils/getMailboxJunkEmailUtils';
import { errorThatWillCauseAlert } from 'owa-trace';
import { updateAccountScopeUserSettingsAndService } from 'owa-userconfiguration/lib/utils/updateAccountScopeUserSettingsAndService';

export default function updateSenderScreeningUserOptionService(
    mailboxInfo: MailboxInfo
): Promise<unknown> {
    const isSenderScreeningEnabled =
        getStoredMailboxJunkEmailConfiguration(mailboxInfo).SenderScreeningEnabled;

    if (isSenderScreeningEnabled === undefined) {
        const error =
            'SenderScreeningEnabled from StoredMailboxJunkEmailConfiguration is undefined';
        errorThatWillCauseAlert(error);
        return Promise.reject(error);
    }

    return updateAccountScopeUserSettingsAndService(mailboxInfo, {
        UserOptions: {
            IsSenderScreeningSettingEnabled: isSenderScreeningEnabled,
        },
    });
}
